import React, { Component } from "react";

import { connect } from "react-redux";
import * as contactActions from "../../../actions/chat/contactActions";
//import * as messageActions from '../../store/actions/messageActions'
import { fetchUsers } from "../../../actions/user.js";
import socket from '../../../helpers/socket';

import FaChevronLeft from "react-icons/lib/fa/chevron-left";
import FaChevronRight from "react-icons/lib/fa/chevron-right";
import "./contactWindow.css";

import Contact from "./contact/contact";

class ContactWindow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contactWindowState: 0,
      users: null,
      filtered: '',
    };

    this.windowStateChangeHandler = this.windowStateChangeHandler.bind(this);
    this.contactModalOpen = this.contactModalOpen.bind(this);
    this.props.contactSetMyId(this.props.myId);
    this.props.fetchUsers();
  }

  windowStateChangeHandler = () => {
    const v = this.state.contactWindowState === 0 ? 1 : 0;
    this.setState({ contactWindowState: v });

    setTimeout(() => {
      if (v === 0) this.props.contactWindowMaximize();
      else this.props.contactWindowMinimize();
    }, 300);
  };

  contactModalOpen = contactId => {
    if (!this.props.contactModals.includes(contactId)) {
      this.props.contactModalOpen(contactId);
    } else {
      this.props.contactModalBlink(contactId);
      setTimeout(() => {
        this.props.contactModalBlink(null);
      }, 300);
    }
  };

  componentDidMount() {
    console.log('componentdidmount');
    this.props.fetchUsers();
    socket.on('messagesOnGetUnreadCount', (data)=>{
      console.log('dataFromSocket', data)
    })
    // this.props.contactsGet()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.contacts && nextProps.myId) {
      this.setState({
        users: nextProps.contacts.filter(c => c.id !== nextProps.myId)
      });

      if (nextProps.unreadCount > 0) {
        this.setState({ contactWindowState: 0 });
      }
    }
  }

  filterUsers = filtered => {
    this.setState({
      filtered
    })
  }

  render() {
    if(!this.state.users) {
      return null;
    }

    let users = this.state.users;
    let onlineUsers = [];

    this.props.onlineUsers.map(onlineUser=>{
      users.map(user=>{
        if(user.id===onlineUser) {
          onlineUsers.push(user)
        }
      })
    })

    onlineUsers.map(onlineUser=>{
      users = users.filter(user=>user.id!=onlineUser.id)
    })

    users = [...onlineUsers, ...users];

    const contactWindowState = this.state.contactWindowState;
    const filteredUsers = users.filter(user=>{
      const name = user.first_name.toLowerCase() + " " + user.last_name.toLowerCase();
      return name.includes(this.state.filtered.toLowerCase());
    })

    return (
      <div
        className={[
          "contactWindowContainer",
          contactWindowState === 0
            ? "contactWindowContainerMax"
            : "contactWindowContainerMin"
        ].join(" ")}
      >
        <div className="contactWindow shadowBox1">
          <button
            className={`btn-blue ${this.props.unreadCount.length > 0 ? 'btn-red' : 'btn-darkBlue'} btn-square`}
            onClick={() => this.windowStateChangeHandler()}
          >
            {contactWindowState === 0 ? (
              <FaChevronRight className="contactWindowArrow" />
            ) : (
                <FaChevronLeft />
              )}
          </button>
          {contactWindowState === 0 && (
            <div className="contactWindowRightPane">
              <div className="contactWindowContactsContainer">
                <div className="contactWindowContacts">
                  {this.state.users &&
                    this.props.unreadCount &&
                    filteredUsers.map((el, i) => {
                      return (
                        <Contact
                          key={i}
                          contactId={el.id}
                          firstName={el.first_name}
                          lastName={el.last_name}
                          contactPhoto={el.profile_photo_url}
                          contactDefaultPhoto={el.color}
                          contactTime={"1ms"}
                          contactOnline={this.props.onlineUsers.includes(el.id)}
                          contactModalOpen={() => this.contactModalOpen(el.id)}
                          unread={this.props.unreadCount.filter(
                            a => a.contactId === el.id
                          )}
                        />
                      );
                    })}
                    {
                      filteredUsers.length===0 && <div>No Results</div>
                    }
                </div>
                <input placeholder="Search" onChange={e=>this.filterUsers(e.target.value)}/>
              </div>
              {/* <ContactSearch /> */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  
  return {
    myId: state.auth.currentUser.id,
    contacts: state.user.allUsers,
    onlineUsers: state.user.onlineUsers,

    contactModals: state.contactReducer.contactModals,
    contactWindowState: state.contactReducer.contactWindowState,
    unreadCount: state.messageReducer.unreadCount
  };
};
const mapDispatchToProps = {
  contactSetMyId: contactActions.contactSetMyId,
  contactWindowMaximize: contactActions.contactWindowMaximize,
  contactWindowMinimize: contactActions.contactWindowMinimize,
  contactsGet: contactActions.contactsGet,
  contactModalBlink: contactActions.contactModalBlink,
  contactModalOpen: contactActions.contactModalOpen,
  fetchUsers
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactWindow);



// WEBPACK FOOTER //
// ./src/common/chat/contactWindow/contactWindow.js